import { useQueryClient } from "@tanstack/react-query";

import type { Route } from "./+types/$locale.locations._index";
import { getLocations } from "@/api/locations";
import { buildSeoMeta } from "@/components/seo/meta";
import { LocationsPage } from "@/features/locations/routes/LocationsPage";

/**
 * Build-time loader for /:locale/locations.
 *
 * Pre-fetches the locations list so the runtime `useLocations` hook inside
 * `<LocationsPage>` (key `['locations']`, see app/hooks/useLocations.ts)
 * returns seeded data on first paint without a network round-trip.
 */
export async function loader() {
    const locations = await getLocations();
    return { locations };
}

export function meta({ params }: Route.MetaArgs) {
    const locale = (params.locale as string) ?? "en";
    return buildSeoMeta({
        title: "Our Locations — Stork Rentals Pickup Points",
        description:
            "Find Stork Rentals pickup locations across Ireland, including Dublin Airport, Cork Airport and more, for convenient baby equipment collection.",
        path: "/locations",
        keywords:
            "baby equipment pickup locations, stroller rental locations, Dublin Airport baby gear, Cork Airport baby gear",
        // TODO Phase 6: hydrate availableLocales from root loader manifest
        locale,
        availableLocales: [{ code: "en" }],
    });
}

export default function LocationsIndexRoute({ loaderData }: Route.ComponentProps) {
    const queryClient = useQueryClient();
    queryClient.setQueryData(["locations"], loaderData.locations);
    return <LocationsPage />;
}
